var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadsetHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 7.333a5.333 5.333 0 0 0-10.666 0",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.333 9.772v-.21a2 2 0 0 1 1.515-1.94l.406-.102A.6.6 0 0 1 4 8.102v3.13a.6.6 0 0 1-.746.582l-.406-.102a2 2 0 0 1-1.515-1.94z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 9.772v-.21a2 2 0 0 0-1.515-1.94l-.407-.102a.6.6 0 0 0-.745.582v3.13a.6.6 0 0 0 .745.582l.407-.102a2 2 0 0 0 1.515-1.94z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 12c0 .92-.746 1.667-1.666 1.667h-2",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.667H7a1 1 0 0 1 0-2h2a1 1 0 1 1 0 2z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadsetHelp);
export default __webpack_public_path__ + "static/media/headset-help.2c3ad3ecd5500ff7f43df4ba308dc197.svg";
export { ForwardRef as ReactComponent };